import { render, staticRenderFns } from "./cnzz.vue?vue&type=template&id=066062ba&scoped=true"
import script from "./cnzz.vue?vue&type=script&lang=js"
export * from "./cnzz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066062ba",
  null
  
)

export default component.exports